import { render, staticRenderFns } from "./AddBaseDocumentsModal.vue?vue&type=template&id=2dda5d10&"
import script from "./AddBaseDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./AddBaseDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddBaseDocumentsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports